__webpack_require__.p = "/bizx-health/noor-v2/";